<template>
  <el-container style="overflow-x: hidden;">
    <el-header  v-show="(path ==='/c') ">
      <o-header></o-header>
    </el-header>
    <el-main style="overflow-x: hidden;">
      <el-scrollbar style="height:100%;overflow-x: hidden;" >
        <router-view></router-view>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
  import oHeader from "@/components/header"
  export default {
    components: {
      oHeader
    },
    data(){
      return {
				path:''
			}
    },
		mounted() {
		    this.path = this.$route.path;
		    // console.log(this.$route.path)
				},
		watch:{
		    $route(to,from){
		        this.path = to.path
		    }  
		},   
    methods:{}
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout.vue